import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Icon } from "../../components/Icon/Icon";
import Close from "../../icons/close.svg";
export const VideoFullscreenDialog = ({ children, onClose }) => {
    useEffect(() => {
        document.body.classList.add("video-player-overlay-open");
        return () => {
            document.body.classList.remove("video-player-overlay-open");
        };
    }, []);
    return (_jsxs("div", { className: "videoPlayerFullscreenOverlay", onClick: onClose, children: [_jsx("div", { className: "videoPlayerFullscreenContent", onClick: (e) => e.stopPropagation(), children: children }), _jsx("button", { className: "videoPlayerFullscreenCloseButton", onClick: onClose, children: _jsx(Icon, { className: "iconClose", component: Close }) })] }));
};
export default VideoFullscreenDialog;
//# sourceMappingURL=VideoFullscreenDialog.js.map